import { FallbackProps } from 'react-error-boundary';

import { ExceptionSection } from '@kakaopay-web-ui/template';

import Header from '~/components/layout/Header';

export const CommonErrorFallback = ({ resetErrorBoundary }: FallbackProps) => {
  return (
    <>
      <Header title={'무지 쓸모있는 투자 소식'} isTitleVisible={false} />

      <ExceptionSection
        icon="CommonError"
        title="잠시 연결이 늦어지고 있습니다."
        description="조금 뒤 다시 시도해 주세요."
        buttonText="다시 시도"
        onClickButton={resetErrorBoundary}
        isFixed
      />
    </>
  );
};
